(function () {
  function init(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';
    var viewport = root.querySelector('.vb-pdp-testimonials__viewport');
    if (!viewport) return;
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    viewport.addEventListener('pointerdown', function (e) {
      isDown = true;
      startX = e.clientX;
      scrollLeft = viewport.scrollLeft;
      viewport.setPointerCapture(e.pointerId);
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      viewport.scrollLeft = scrollLeft - (e.clientX - startX);
    });
    viewport.addEventListener('pointerup', function () { isDown = false; });
    viewport.addEventListener('pointercancel', function () { isDown = false; });
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-testimonials]').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-vb-pdp-testimonials]');
    if (r) { r.dataset.init = '0'; init(r); }
  });
})();
